import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  Modal,
  DropdownButton,
  MenuItem,
  ButtonGroup,
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { get_faq_list, delete_faq } from "../../../redux/actions/faqAction";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import loader from "../../../style/loader/loader.scss";
import { aclUtil } from "../../util";

const history = createBrowserHistory();
class FaqList extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      menuKey: "LIST_FAQ",
      faqList: [],
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      limit: 25,
      pageCount: 0,
      alertMessage: "",
      msgType: "",
      path: ["Home", "FAQ List"],
      links: ["home", "faqList"],
      show: false,
      weightSortIcon: "",
      created_onSortIcon: "",
      direction: "",
      orderBy: "",
      searchString: "",
      faq: "",
      showModal: false,
      question: "",
      answer: "",
      multi_lang: "no",
    };
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleSort = (orderBy) => (e) => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy,
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy,
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy,
      });
    }
    this.props.get_faq_list({
      page: this.state.currentPage,
      orderBy: orderBy,
      direction: direction,
      limit: this.state.limit,
    });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false, french_answer: "", french_question: "" });
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));

    if (siteData) {
      if (siteData.multi_lang) {
        this.setState({
          multi_lang: siteData.multi_lang,
        });
      }
    }
    this.handleDismiss();
    this.props.clearAlert();
    this.props.get_faq_list({
      page: this.state.currentPage,
      limit: this.state.limit,
    });
  }
  handlePageChange = (page) => {
    this.setState({
      currentPage: page,
    });
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.get_faq_list({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit,
      });
    } else if (this.state.searchString !== "") {
      this.props.get_faq_list({
        page: page,
        search: this.state.searchString,
        limit: this.state.limit,
      });
    } else {
      this.props.get_faq_list({ page: page, limit: this.state.limit });
    }
  };

  handleSearch = () => (e) => {
    const searchString = e.target.value;
    if (searchString.length > 0) {
      this.props.get_faq_list({
        search: searchString,
        page: this.state.currentPage,
      });
    } else {
      this.props.get_faq_list({
        page: this.state.currentPage,
        limit: this.state.limit,
      });
    }
    this.setState({ searchString: searchString });
  };

  componentWillReceiveProps(nextProps) {
    if (!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)) {
      this.context.router.history.push("/restrictedAccess");
    }
    if (
      this.props.faqList !== nextProps.faqList &&
      !isEmpty(nextProps.faqList)
    ) {
      if (nextProps.faqList.data) {
        const setPageCount =
          nextProps.faqList.total / nextProps.faqList.per_page;
        this.setState({
          faqList: nextProps.faqList.data,
          totalRecords: nextProps.faqList.total,
          perPage: nextProps.faqList.per_page,
          pageCount: setPageCount,
        });
      }
    }
    if (this.props.deleteFaqResponse !== nextProps.deleteFaqResponse) {
      if (nextProps.deleteFaqResponse) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.deleteFaqResponse.message);
        this.handlePageChange(this.state.currentPage);
      }
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.setState({ alertMessage: nextProps.message });
    }
    if (nextProps.alertType) {
      this.setState({ msgType: nextProps.alertType });
    }
  }
  handleView = (question, answer, french_answer, french_question) => {
    this.setState({
      question: question,
      answer: answer,
      showModal: true,
      french_answer: french_answer,
      french_question: french_question,
    });
  };

  handleDelete = (quesID) => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(quesID);
        }),
      ],
    });
  };

  confirmDelete = (quesID) => {
    this.props.delete_faq(quesID);
  };

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let faqRow;
    if (!isEmpty(this.props.faqList) && this.props.faqList.data.length > 0) {
      faqRow = this.props.faqList.data.map((faq, index) => (
        <tr key={faq.quesID}>
          <td>{faq.created_on}</td>
          <td>
            {faq.question.length > 30
              ? `${faq.question.substr(0, 30)}...`
              : faq.question}
          </td>
          <td>
            {faq.answer.length > 30
              ? `${faq.answer.substr(0, 30)}...`
              : faq.answer}
          </td>
          <td>{faq.weight}</td>
          <td>{faq.status}</td>
          <td>{faq.thumsDown}</td>
          <td>{faq.thumsUp}</td>
          <td>
            <ButtonGroup>
              <DropdownButton title="Action" id="bg-nested-dropdown1">
                {aclUtil.checkACL("VIEW_FAQ") ? (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.handleView.bind(
                      this,
                      faq.question,
                      faq.answer,
                      faq.french_answer,
                      faq.french_question
                    )}
                  >
                    <i className="glyphicon glyphicon-eye-open"></i> View
                  </MenuItem>
                ) : (
                  ""
                )}
                {aclUtil.checkACL("EDIT_FAQ") ? (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={() =>
                      this.context.router.history.push(`/editFaq/${faq.quesID}`)
                    }
                  >
                    <i className="glyphicon glyphicon-pencil"></i> Edit
                  </MenuItem>
                ) : (
                  ""
                )}
                {aclUtil.checkACL("DELETE_FAQ") ? (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.handleDelete.bind(this, faq.quesID)}
                  >
                    <i className="glyphicon glyphicon-trash"></i> Delete
                  </MenuItem>
                ) : (
                  ""
                )}
              </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        <Dialog
          ref={(el) => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 faq-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent
                path={this.state.path}
                links={this.state.links}
                context={this.context}
              />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">faq List</header>
            <div className="panel-body">
              {this.state.show && this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType.toLowerCase()}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}

              <div className="col-lg-12 text-right">
                {aclUtil.checkACL("ADD_FAQ") ? (
                  <Button
                    bsSize="small"
                    bsStyle="success"
                    onClick={() => this.context.router.history.push("/addFaq")}
                  >
                    + Add New Question
                  </Button>
                ) : (
                  ""
                )}
              </div>
              <div className="clearfix" />
              <div className="row m-t-15">
                <div className="col-lg-4 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" onKeyUp={this.handleSearch()} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
              <div className="col-lg-12">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th onClick={this.handleSort("created_on")}>
                        Created On
                        <span
                          className={this.state.created_onSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th>Question</th>
                      <th>Answer</th>
                      <th onClick={this.handleSort("weight")}>
                        Weight
                        <span
                          className={this.state.weightSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th>Status</th>
                      <th>Thumbs Down</th>
                      <th>Thumbs Up</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>{faqRow}</tbody>
                </table>

                <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps,
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange,
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange,
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map((page) => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666",
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange,
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange,
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange,
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
        <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title style={{ textTransform: "capitalize" }}>
              View Question
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Question:</h4>
            <p>{this.state.question}</p>
            <h4>Answer:</h4>
            <p>{this.state.answer}</p>
            {this.state.french_question && this.state.multi_lang == "yes" && (
              <h4>Question (Canadian French):</h4>
            )}
            {this.state.french_question && this.state.multi_lang == "yes" && (
              <p>{this.state.french_question}</p>
            )}

            {this.state.french_answer && this.state.multi_lang == "yes" && (
              <h4>Answer (Canadian French):</h4>
            )}
            {this.state.french_answer && this.state.multi_lang == "yes" && (
              <p>{this.state.french_answer}</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleCloseModal}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

FaqList.propTypes = {
  get_faq_list: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  faqList: state.faqReducer.faqList,
  error: state.faqReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  deleteFaqResponse: state.faqReducer.deleteFaqResponse,
  receivingFaqList: state.faqReducer.receivingFaqList,
});

export default withRouter(
  connect(mapStateToProps, {
    delete_faq,
    get_faq_list,
    renderAlert,
    clearAlert,
  })(FaqList)
);



// WEBPACK FOOTER //
// ./src/app/views/admin/faq/faqList.js